export enum SearchType {
    DOOR,
    COLOR,
    EDGE_COLOR,
}
